import { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';

import { PageHeader, Link } from 'shared-components';

import QuestionPage from '../../../templates/question';
import Checkbox from '../../../molecules/checkboxQuestion';
import { Q } from '../../../../store/student/types';
import { titleAppend } from '../../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import * as StudentActions from '../../../../store/student/actions';
import {
  createNavigateForwardAction,
  createNavigateBackwardAction,
  createNavigateToAction
} from '../../../../middleware/actions';
import { Pages } from '../../../../store/student/consents/types';
import { toggleTaskMenu } from '../../../../store/ui/actions';

const currentStep = 4;
const steps = 4;
const ConsentsQPage4 = () => {
  const isPage4Complete = useSelector((state: ApplicationState) => state.student.consents.isPage4Complete);
  const config = useSelector((state: ApplicationState) => state.config.Checklist.Consents);

  const [consent, setConsent] = useState(isPage4Complete || false);

  const dispatch = useDispatch();
  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = config => {
    dispatch(StudentActions.saveConsents(Pages.PAGE4, config));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  useEffect(() => {
    setConsent(isPage4Complete ?? false);
  }, [isPage4Complete]);

  return (
    <QuestionPage
      complete={consent}
      currentStep={currentStep}
      steps={steps}
      onPrevious={onPrevious}
      onNext={() => onNext(config)}
      onSkip={onSkip}
      onBackToTaskList={onBackToTaskList}
    >
      <Helmet>
        <title>
          {config.Page4.heading ? config.Page4.heading : config.Page4.title} {titleAppend}
        </title>
      </Helmet>

      <PageHeader>{config.Page4.heading ? config.Page4.heading : config.Page4.title}</PageHeader>

      <Text
        data-selector="blurb"
        fontSize="lg"
        dangerouslySetInnerHTML={{
          __html: config.Page4.blurb
        }}
        sx={{
          'p, ol, ul': {
            mb: 4
          },
          li: {
            ml: 12
          }
        }}
      />

      {config?.Page4?.externalLinkInstruction ? (
        <Text
          fontSize="lg"
          data-selector="instruction"
          dangerouslySetInnerHTML={{
            __html: config.Page4.externalLinkInstruction
          }}
        />
      ) : null}

      {config?.Page4?.externalLink ? (
        <Link href={config.Page4.externalLink} isExternal>
          {config?.Page4?.externalLinkText ?? 'View Terms and Conditions'}
        </Link>
      ) : null}

      {config?.Page4?.externalLinkList?.length
        ? config?.Page4?.externalLinkList.map(({ link, linkText }: { link: string; linkText: string }) => (
            <Text>
              <Link href={link} isExternal>
                {linkText}
              </Link>
            </Text>
          ))
        : null}

      <Checkbox
        blurb={config?.Page4?.additionalBlurb ?? ''}
        key={Q.CONSENTS_4}
        id={Q.CONSENTS_4}
        isTicked={consent}
        checkboxLabel={config?.Page4?.confirmCheckboxText ?? 'I Agree'}
        onChange={(_key: string, isTicked: boolean) => setConsent(isTicked)}
      />
    </QuestionPage>
  );
};

export default ConsentsQPage4;
